import type { InternalAxiosRequestConfig } from "axios";
import createAxiosInstance from "@/api/config/createAxiosInstance";
import { WOO_REST_API_PATH_PROXY } from "@shared/config/constants";

const baseURL = WOO_REST_API_PATH_PROXY; // 呼叫專案中的 Serverless Function API 路由，並由該路由轉發請求至 WooCommerce REST API，避免前端直接呼叫而透露金鑰，金鑰由 Serverless 後端環境轉發時夾帶

const handleRequestConfig = (config: InternalAxiosRequestConfig) => {
  config.params = {
    ...config.params,
  };

  return Promise.resolve(config);
};

const wooRestApi = createAxiosInstance(baseURL, handleRequestConfig);

export { wooRestApi };

